import validate from '../../../services/reduxValidate.js'

export default function(data) {
  return validate(data, {
    label: {
      presence: { allowEmpty: false },
      length: {
        maximum: 255,
        message: 'La certification ne peut pas dépasser 255 caractères.'
      }
    },
    date: { isoDate: true }
  })
}
